(function () {
  var STORAGE_PREFIX = 'announcement_bar_trends_wd_';

  function storageKey(sectionId) {
    return STORAGE_PREFIX + (sectionId || 'default');
  }

  var SECTION_SELECTOR = '.shopify-section.section-announcement-bar-trends-wd, .shopify-section.section-promo-scrolling-bar';

  function getAnnouncementSection(el) {
    return el.closest(SECTION_SELECTOR);
  }

  function slideToggle(el) {
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease';
    var height = el.offsetHeight;
    el.style.maxHeight = height + 'px';
    el.style.opacity = '1';
    requestAnimationFrame(function () {
      el.style.maxHeight = '0';
      el.style.opacity = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
    });
    setTimeout(function () {
      el.classList.add('is-hidden');
      var section = getAnnouncementSection(el);
      if (section) section.classList.add('is-hidden');
      el.style.removeProperty('max-height');
      el.style.removeProperty('opacity');
      el.style.removeProperty('overflow');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
    }, 320);
  }

  function initAnnouncementBars() {
    document.querySelectorAll('[data-twd-announcement-bar]').forEach(function (bar) {
      var sectionId = bar.dataset.sectionId;
      var section = getAnnouncementSection(bar);

      if (sessionStorage.getItem(storageKey(sectionId)) === 'false') {
        bar.classList.add('is-hidden');
        if (section) section.classList.add('is-hidden');
        return;
      }

      var close = bar.querySelector('.twd-announcement-bar__close');
      if (!close || close.dataset.bound === 'true') return;
      close.dataset.bound = 'true';
      close.addEventListener('click', function () {
        slideToggle(bar);
        sessionStorage.setItem(storageKey(sectionId), 'false');
      });
    });
  }

  class TwdSlideSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      var slides = Array.prototype.slice.call(this.querySelectorAll('.twd-announcement-bar__slide'));
      if (slides.length < 2) return;

      var index = 0;
      var autoplay = this.dataset.autoplay === 'true';
      var speed = parseInt(this.dataset.autoplaySpeed || '3', 10) * 1000;
      var prev = this.parentElement.querySelector('.twd-announcement-bar__arrow--prev');
      var next = this.parentElement.querySelector('.twd-announcement-bar__arrow--next');
      var timer;

      function show(i) {
        slides.forEach(function (slide, idx) {
          slide.classList.toggle('is-active', idx === i);
        });
      }

      function go(delta) {
        index = (index + delta + slides.length) % slides.length;
        show(index);
      }

      show(0);

      if (prev) prev.addEventListener('click', function () { go(-1); resetTimer(); });
      if (next) next.addEventListener('click', function () { go(1); resetTimer(); });

      function resetTimer() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(1); }, speed);
      }

      if (autoplay) resetTimer();
    }
  }

  class TwdCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.format = this.dataset.format || 'dd:hh:mm:ss';
      this.interval = null;
      this.renderShell();
      var endtime = this.dataset.endtime;
      if (endtime) {
        var iso = this.resolveIsoDate(endtime);
        if (iso) this.start(iso);
      }
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    resolveIsoDate(value) {
      var cddl = (value || '').trim();
      if (!cddl || cddl === '00' || cddl === '0') return '';

      if (/^\d{4}-\d{2}-\d{2}T/.test(cddl)) return cddl;

      if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(cddl)) {
        return new Date(cddl).toISOString();
      }

      if (/^\d{2}-\d{2}-\d{4}$/.test(cddl)) {
        var parts = cddl.split('-');
        return parts[2] + '-' + parts[0].padStart(2, '0') + '-' + parts[1].padStart(2, '0') + 'T00:00:00Z';
      }

      return '';
    }

    renderShell() {
      var days = this.dataset.days || '';
      var hours = this.dataset.hours || '';
      var mins = this.dataset.mins || '';
      var secs = this.dataset.secs || '';
      var html = '';

      if (this.format.indexOf('dd') !== -1) {
        html += '<span class="twd-countdown__unit"><span class="twd-countdown__digits days_timer">00</span>' +
          (days ? '<span class="twd-countdown__label">' + days + '</span>' : '') + '</span>';
      }
      if (this.format.indexOf('hh') !== -1) {
        html += '<span class="twd-countdown__unit"><span class="twd-countdown__digits hours_timer">00</span>' +
          (hours ? '<span class="twd-countdown__label">' + hours + '</span>' : '') + '</span>';
      }
      if (this.format.indexOf('mm') !== -1) {
        html += '<span class="twd-countdown__unit"><span class="twd-countdown__digits minutes_timer">00</span>' +
          (mins ? '<span class="twd-countdown__label">' + mins + '</span>' : '') + '</span>';
      }
      if (this.format.indexOf('ss') !== -1) {
        html += '<span class="twd-countdown__unit"><span class="twd-countdown__digits seconds_timer">00</span>' +
          (secs ? '<span class="twd-countdown__label">' + secs + '</span>' : '') + '</span>';
      }

      this.innerHTML = html;
    }

    start(isoDate) {
      var deadline = Date.parse(isoDate);
      var self = this;

      function calc(diff) {
        var left = {};
        if (self.format.indexOf('dd') !== -1) {
          left.days = Math.floor(diff / (1000 * 60 * 60 * 24));
        }
        if (self.format.indexOf('hh') !== -1) {
          left.hours = self.format.indexOf('dd') !== -1
            ? Math.floor((diff / (1000 * 60 * 60)) % 24)
            : Math.floor(diff / (1000 * 60 * 60));
        }
        if (self.format.indexOf('mm') !== -1) {
          left.minutes = Math.floor((diff / 1000 / 60) % 60);
        }
        if (self.format.indexOf('ss') !== -1) {
          left.seconds = Math.floor((diff / 1000) % 60);
        }
        return left;
      }

      function paint(left) {
        Object.keys(left).forEach(function (key) {
          var el = self.querySelector('.' + key + '_timer');
          if (el) el.textContent = String(left[key]).padStart(2, '0');
        });
        self.classList.remove('is-hidden');
      }

      function tick() {
        var diff = deadline - Date.now();
        var left = diff > 0 ? calc(diff) : calc(0);
        var hasTime = (left.days || 0) > 0 || (left.hours || 0) > 0 ||
          (left.minutes || 0) > 0 || (left.seconds || 0) > 0;

        if (!hasTime) {
          clearInterval(self.interval);
          self.classList.add('is-hidden');
          return;
        }
        paint(left);
      }

      tick();
      this.interval = setInterval(tick, 1000);
    }
  }

  if (!customElements.get('twd-slide-section')) {
    customElements.define('twd-slide-section', TwdSlideSection);
  }
  if (!customElements.get('twd-countdown-timer')) {
    customElements.define('twd-countdown-timer', TwdCountdownTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBars);
  } else {
    initAnnouncementBars();
  }

  document.addEventListener('shopify:section:load', initAnnouncementBars);
})();
